import { useToastStore } from '../../store/toastStore';

export const Toast = () => {
  const { toasts, removeToast } = useToastStore();

  const icons = {
    success: 'ri-checkbox-circle-fill text-success-500',
    error: 'ri-error-warning-fill text-danger-500',
    warning: 'ri-alert-fill text-warning-500',
    info: 'ri-information-fill text-primary-500',
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="bg-white rounded-xl shadow-hover p-4 min-w-[300px] flex items-start gap-3 animate-slide-in"
        >
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className={`${icons[toast.type]} text-xl`}></i>
          </div>
          <p className="flex-1 text-sm text-gray-700">{toast.message}</p>
          <button
            onClick={() => removeToast(toast.id)}
            className="w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer flex-shrink-0"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      ))}
    </div>
  );
};
